module.exports = __webpack_public_path__ + "img/location - 副本.5747d895.5747d895.png";